import Comments from "@common-components/comments/Comments";
import CCP_ActionCards from "@common-components/ccp-cards/CCP_ActionCards";
import CCP_ImageCards from "@common-components/ccp-cards/CCP_ImageCards";
import React, { useEffect } from "react";
import CCP_API from "api/ccpAPi";
import { useFetch } from "@hooks/useCcpApi";
import CommentsCCP from "@common-components/comments/CommentsCCp";
import { useLocation } from "react-router-dom";
import { Button, LoadIndicator } from "devextreme-react";
import notify from "devextreme/ui/notify";
import { Accordion } from "devextreme-react/accordion";
import DocCards from "@components/QCP/DocCards";
import { useNavigate } from "react-router-dom";
import Loader from "@common-components/loader/Loader";

export default function CCP() {
  const queryParams = new URLSearchParams(window.location.search);
  const batchNumFromParams = queryParams.get("batchNum");
  const navigate = useNavigate();

  const [batch, setBatch] = React.useState(
    batchNumFromParams || localStorage.getItem("batchNum")
  );
  const location = useLocation();
  const {
    data: CCP_Product,
    isLoading: isqcpProductLoading,
    refetch,
  } = useFetch("getProductTestccp", CCP_API.ccpProduct, { batchNo: batch });

  useEffect(() => {
    refetch();
  }, [batch]);

  const getBgColor = (progress) => {
    let bgColor = "";

    switch (progress?.toLowerCase()) {
      case "completed":
        bgColor = "bg-green-300";
        break;
      case "on hold":
        bgColor = "bg-gray-300 text-gray-700";
        break;
      case "in progress":
        bgColor = "bg-yellow-300 text-gray-700";
        break;
      case "new":
        bgColor = "bg-blue-300";
        break;
      default:
        bgColor = "bg-gray-200 text-gray-700";
    }

    return bgColor;
  };

  console.log(CCP_Product, "ccpProduct");

  useEffect(() => {
    if (!batch || batch === "undefined") {
      notify({
        message:
          "Please select a batch number from the overview to see results.",
        type: "error",
        displayTime: 3000,
        position: {
          my: "top right",
          at: "top right",
          of: window,
        },
      });
    }
  }, [batch]);

  // render QCP Test result in accordion form
  const accordionItems = CCP_Product?.data.sort((a, b) => a.type - b.type);
  const renderQcpTestContent = (item) => {
    if (item.type === 1) {
      return (
        <>
          <p>Test for broken glass or other fragile material incl. fragments</p>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 mt-3">
            <div className="lg:col-span-2 flex flex-col gap-3">
              {item && (
                <div>
                  <CCP_ActionCards
                    data={CCP_Product?.data.find((data) => data.type === 1)}
                  />
                </div>
              )}
              <>
                {CCP_Product?.data.find((data) => data.type === 1)?.ccpimage
                  .length > 0 && (
                  <>
                    <div className="w-full flex items-center lg:mt-4 mt-0">
                      <p className="whitespace-nowrap text-xl font-medium mb-0">
                        Picture(s):
                      </p>
                      <div className="flex-grow h-px bg-gray-300 light-bg ml-2"></div>
                    </div>
                    <div>
                      <CCP_ImageCards
                        images={
                          CCP_Product?.data.find((data) => data.type === 1)
                            ?.ccpimage
                        }
                      />
                    </div>
                  </>
                )}
                {CCP_Product?.data.find((data) => data.type === 1)?.documents
                  ?.length > 0 && (
                  <>
                    <div className="w-full flex items-center lg:mt-4 mt-0">
                      <p className="whitespace-nowrap text-xl font-medium mb-0">
                        Attachment(s):
                      </p>
                      <div className="flex-grow h-px bg-gray-300 light-bg ml-2"></div>
                    </div>
                    <div>
                      <DocCards
                        doc={
                          CCP_Product?.data.find((data) => data.type === 1)
                            ?.documents
                        }
                      />
                    </div>
                  </>
                )}
              </>
            </div>
            <div>
              <CommentsCCP
                comment={
                  CCP_Product?.data.find((data) => data.type === 1)?.ccpcomments
                }
              />
            </div>
          </div>
        </>
      );
    } else if (item.type === 2) {
      return (
        <>
         
          <p>Ensure all tools introduced at production start.</p>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 mt-3">
            <div className="lg:col-span-2 flex flex-col gap-3">
              {item && (
                <div>
                  <CCP_ActionCards
                    data={CCP_Product?.data.find((data) => data.type === 2)}
                  />
                </div>
              )}
              <>
                {CCP_Product?.data.find((data) => data.type === 2)?.ccpimage
                  .length > 0 && (
                  <>
                    <div className="w-full flex items-center lg:mt-4 mt-0">
                      <p className="whitespace-nowrap text-xl font-medium mb-0">
                        Picture(s):
                      </p>
                      <div className="flex-grow h-px bg-gray-300 light-bg ml-2"></div>
                    </div>
                    <div>
                      <CCP_ImageCards
                        images={
                          CCP_Product?.data.find((data) => data.type === 2)
                            ?.ccpimage
                        }
                      />
                    </div>
                  </>
                )}
                {CCP_Product?.data.find((data) => data.type === 2)?.documents
                  ?.length > 0 && (
                  <>
                    <div className="w-full flex items-center lg:mt-4 mt-0">
                      <p className="whitespace-nowrap text-xl font-medium mb-0">
                        Attachment(s):
                      </p>
                      <div className="flex-grow h-px bg-gray-300 light-bg ml-2"></div>
                    </div>
                    <div>
                      <DocCards
                        doc={
                          CCP_Product?.data.find((data) => data.type === 2)
                            ?.documents
                        }
                      />
                    </div>
                  </>
                )}
              </>
            </div>
            <div>
              <CommentsCCP
                comment={
                  CCP_Product?.data.find((data) => data.type === 2)?.ccpcomments
                }
              />
            </div>
          </div>
        </>
      );
    }
  };

  return (
    <>
      {isqcpProductLoading ? (
        <div className="flex justify-center items-center h-full mt-10">
          <Loader />
        </div>
      ) : (
        <>
         <div className="flex justify-end mb-3 me-3">
            <Button
              onClick={() => { navigate("/quality/fillet/ccp") }}
              width={120}
              text="Add CCP"
              className="w-auto"
              stylingMode="contained"
              type="default"
            />
          </div>
        <div className="dx-card responsive-paddings">
          <div className="w-full lg:w-auto flex items-center space-x-4">
            <p className="font-semibold text-lg mb-0">Batch No:</p>
            <span className="font-normal">
              {batch !== "undefined" ? batch : ""}
            </span>
          </div>
          {CCP_Product.data.length > 0 ? (
            <Accordion
              dataSource={accordionItems}
              // visible={CCP_Product.data.length > 0}
              collapsible={true}
              multiple={true}
              animationDuration={300}
              itemTitleRender={(item) => {
                const status = CCP_Product?.data?.find(
                  (data) => data.type === item.type
                )?.status?.description;

                console.log(item, "sssup");

                return (
                  <div className="flex gap-2 items-center">
                    {item.type === 1 && "Test Type: Production Startup"}
                    {item.type === 2 && "Test Type: End Production"}
                    {status && (
                      <div className={`${getBgColor(status)} p-1 rounded-md`}>
                        {status}
                      </div>
                    )}
                  </div>
                );
              }}
              itemRender={renderQcpTestContent}
            />
          ) : (
            <p className="text-center No Data Found">No Data Found</p>
          )}
        </div>
        </>
      )}
    </>
  );
}
